module fdm.aircrafts {

    class AircraftDetailsController implements ng.IController {
        public currentYear: number;
        public queryResult: any;

        constructor() {
            this.currentYear = new Date().getUTCFullYear();
        }

        $onInit() {

        }
    }
    angular.module('fdm.aircrafts').component('aircraftDetails', {
        bindings: {
            queryResult: '<'
        },
        controller: AircraftDetailsController,    
        templateUrl: '/app/src/aircrafts/aircraft-details.html'
    });
}